import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';

import { SharedModule } from '../../../core/modules/shared.module';


import { ControlEscrituraComponent } from './ControlEscrituras.component';

import { RoleGuardService as RoleGuard } from './../Seguridad/role-guard.service';


const routes = [
    {
        path     : 'ControlEscrituras',
        component: ControlEscrituraComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ControlEscrituras'
        } 
    },
    {
        path     : 'ControlEscrituras/:editar/:cnumcont/:vidEscritura/:cprefijo/:vdescripcion',
        component: ControlEscrituraComponent,
        canActivate: [RoleGuard], 
        data: { 
          formulario: 'ControlEscrituras',
          nombreFormulario : 'ControlEscrituras'
        } 
    }
];

@NgModule({
    declarations: [
        ControlEscrituraComponent
    ],
    imports     : [
        SharedModule,
        RouterModule.forChild(routes)
    ],
    exports     : [
        ControlEscrituraComponent
    ],
    bootstrap: [ControlEscrituraComponent]
})


export class ControlEscrituraModule
{
}




// WEBPACK FOOTER //
// D:/Repositorios/FacturacionWeb/src/app/main/content/ControlEscrituras/ControlEscrituras.module.ts